import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import type { ApplicationSdk } from '../../../core/sdk';
import SystemSettingStore from '../stores/SystemSettingStore';
import { ProgressSpinner } from 'primereact/progressspinner';
import { formatNumber } from '../../../utils/helper';
import './SystemSettings.css';
import SettingApiTokens from './ApiKeySettings';
import S3Settings from './S3Settings';
import UChatSettings from './UChatSettings';

const SettingLicense = observer(({ store }: { store: SystemSettingStore }) => {
    return (
        <Card
            title="Lizenz Verwaltung"
            style={{
                marginBottom: '1rem',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
            }}
        >
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                    <label
                        style={{
                            display: 'block',
                            marginBottom: '0.5rem',
                            fontWeight: 'bold',
                        }}
                    >
                        Aktuell genutzte Lizenzen
                    </label>
                    <p
                        style={{
                            margin: 0,
                            padding: '0.5rem',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            fontSize: '1.1rem',
                            fontWeight: 'bold',
                            color: '#1976d2',
                        }}
                    >
                        {formatNumber(store.employeeCount)}
                    </p>
                </div>
                <div>
                    <label
                        style={{
                            display: 'block',
                            marginBottom: '0.5rem',
                            fontWeight: 'bold',
                        }}
                    >
                        Verfügbare Lizenzen
                    </label>
                    <p
                        style={{
                            margin: 0,
                            padding: '0.5rem',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            fontSize: '1.1rem',
                            fontWeight: 'bold',
                            color: '#28a745',
                        }}
                    >
                        {formatNumber(store.employeeLicenses)}
                    </p>
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    gap: '0.5rem',
                    justifyContent: 'center',
                    marginTop: '2rem',
                }}
            >
                <Button
                    label="Bearbeiten"
                    icon="pi pi-pencil"
                    onClick={() => store.editLicenses()}
                    className="p-button-outlined"
                    style={{ padding: '0.5rem 1rem' }}
                />
            </div>
        </Card>
    );
});

const SystemSettings = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    useEffect(() => {
        sdk.useStore(SystemSettingStore);
    }, [sdk]);

    const store = sdk.currentStore;

    if (!store || store.isLoading) {
        return (
            <div
                style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    padding: '2rem',
                    minHeight: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <ProgressSpinner style={{ display: 'block', margin: '2rem auto' }} />
            </div>
        );
    }
    return (
        <div
            style={{
                maxWidth: '800px',
                margin: '0 auto',
                padding: '2rem',
                minHeight: '100vh',
            }}
        >
            <div className="p-fluid">
                <SettingLicense store={store} />
                <S3Settings
                    store={store}
                    sdk={sdk}
                />
                <UChatSettings
                    store={store}
                    sdk={sdk}
                />
                <SettingApiTokens
                    store={store}
                    sdk={sdk}
                />
            </div>
        </div>
    );
});

export default SystemSettings;
